import * as assign from 'lodash/assign';
import * as debounce from 'lodash/debounce';
import * as moment from 'moment';
import {
    adminNotificationDataSource,
    dismissAll,
    dismissForMail
} from '../modules/admin/api/adminnotifications';
import { States } from './services';

const INITIAL_STATE = {
    webpushChannel: null,
    notifications: null,
    showNotifs: null
} as States.IAppNotifications;

export function notificationsReducer(state = INITIAL_STATE, action = { type: '', payload: null }) {
    switch (action.type) {
        case "APP_SETWEBPUSHCHANNEL": {
            return assign({}, state, {
                webpushChannel: action.payload
            });
        }
        case "APP_SETUSERNOTIF": {
            return assign({}, state, action.payload);
        }
        default:
            return state;
    }
}
const popForRelativeKinds = ["massupdate", "massdelete", "dataexport", "mailschedule", "anonymizationreport", "anonymize"];
function isAllowedToPop(notif) {
    if (notif.relatedToKind.indexOf("deportedcommand-") === 0) {
        return true;
    }
    if (popForRelativeKinds.findIndex((k) => k.toLowerCase() === notif.relatedToKind?.toLowerCase()) >= 0) {
        return true;
    }

    return false;
}

export const notificationsActions = {
    setPushChannel() {
        return () => {
        };
    },

    debouncedCheckUnread() {
        return () => {
            return Promise.resolve();
        };
    },

    checkUnread(init = false) {
        return (dispatch, getState: () => States.IAppState) => {
            const notifdata = adminNotificationDataSource();
            const query = {
                order: [{ by: 'messageDate', desc: true }],
                filters: {
                    dismissed: { $neq: true },
                    messageDate: { $gte: moment().add(-7, "days").toISOString()}
                }
            };

            return Promise.all([
                notifdata.count(query),
                notifdata.query(Object.assign({}, query, {
                    page: { returnTotalCount: true, index: 0, size: 100 }
                }))
            ]).then((queryResult) => {
                const count = queryResult[0];
                const notifs = queryResult[1];
                const state = getState();

                if (!init) {
                    const oldnotifs = state.notifications.notifications;
                    const newnotifs = notifs.data.filter((n) => {
                        const existing = oldnotifs.filter((on) => on.id === n.id)[0];
                        return !existing || existing.state !== n.state;
                    });

                    if (newnotifs.some((n) => isAllowedToPop(n))) {
                        setTimeout(() => {
                            dispatch({ type: "APP_SETUSERNOTIF", payload: { showNotifs: new Date() } });
                        }, 0);
                    }
                }
                dispatch({ type: "APP_SETUSERNOTIF", payload: { notifications: notifs.data, notificationsCount: count } });
            }, (err) => {
                console.error("error getting user notifications", err);
            });
        };
    },

    dismiss(notifid: string, delay?: Promise<any>) {
        return (dispatch, getState: () => States.IAppState) => {
            const notifdata = adminNotificationDataSource();
            return notifdata.delete([notifid], true).then(() => {
                if (delay) {
                    return delay;
                }
            }).then(() => {
                notificationsActions.checkUnread()(dispatch, getState);
            });
        };
    },

    dismissForMail(mailid: string) {
        return (dispatch, getState: () => States.IAppState) => {
            return dismissForMail(mailid).then(() => {
                notificationsActions.checkUnread()(dispatch, getState);
            });
        };
    },

    dismissAll() {
        return (dispatch, getState: () => States.IAppState) => {
            return dismissAll().then(() => {
                notificationsActions.checkUnread()(dispatch, getState);
            });
        };
    }
};

notificationsActions.debouncedCheckUnread = debounce((init, dispatch,
    getState) => notificationsActions.checkUnread(init)(dispatch, getState), 60000);

export function initNotifications(_inwink) {
    const inwink = _inwink;
    inwink.registerWebPush = () => {
        notificationsActions.setPushChannel();
    };
}
